import { BarcodeQuestionConfig } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { PRINT_SHEET_CLASS as C } from '../printStyles';
import { RoutinePrintQuestion } from './types';

const MULTIPLE_ENTRY_ROWS = 3;

export const BarcodePrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const barcode = config as BarcodeQuestionConfig;
  const { t } = useTranslation();
  const rows = barcode.allowMultiple ? MULTIPLE_ENTRY_ROWS : 1;

  return (
    <table className={`${C}__table`}>
      <thead>
        <tr>
          <th>{t('routine.print.barcode', 'Barcode')}</th>
          {barcode.includeQuantity ? (
            <th style={{ width: '1.1in' }}>{t('routine.print.quantity', 'Qty')}</th>
          ) : null}
          {barcode.includeMemo ? (
            <th style={{ width: '2.4in' }}>{t('routine.print.memo', 'Memo')}</th>
          ) : null}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }, (_, index) => (
          <tr key={index}>
            <td />
            {barcode.includeQuantity ? <td /> : null}
            {barcode.includeMemo ? <td /> : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
